class MainLogin extends HTMLElement {
  isForgotView = false;
  loginElem?: HTMLElement;
  recoverElem?: HTMLElement;

  constructor() {
    super();
  }

  connectedCallback() {
    this.loginElem = this.querySelector("[data-login]") as HTMLElement;
    this.recoverElem = this.querySelector("[data-recover]") as HTMLElement;
    this.switchForm = this.switchForm.bind(this);

    this.querySelectorAll("[data-switchform]")?.forEach((btn) => {
      btn.addEventListener("click", this.switchForm);
    });

    this.switchForm(null, window.location.hash);
  }

  switchForm(e: Event | null, href?: string) {
    e?.preventDefault();

    if (e && !href) {
      href = e.target.getAttribute("href");
    }

    if (!href) return;

    if (href === "#recover") {
      this.recoverElem.classList.remove("hidden");
      this.loginElem.classList.add("hidden");
    } else if (href === "#login") {
      this.recoverElem.classList.add("hidden");
      this.loginElem.classList.remove("hidden");
    }

    window.location.hash = href;
  }
}

customElements.define("main-login", MainLogin);
